import '../../../packages/ui/src/i18n/i18n';
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import styles from "./styles/index.module.css";
import Dashboard from "../../../packages/ui/src/components/Dashboard";
import { MainSendCashScreen } from "../../../packages/ui/src/components/features/send/screens/MainSendCashScreen";
import { MainReceiveScreen } from "../../../packages/ui/src/components/features/receive/screens/MainReceiveScreen";
import { MainBillPayScreen } from "../../../packages/ui/src/components/features/billPay/screens/MainBillPayScreen";
import GlobalLoader from "../../../packages/ui/src/components/uiComponents/GlobalLoader";
import { GlobalErrorProvider }  from '../../../packages/ui/src/components/uiComponents/GlobalErrorProvider';
import { useSessionStore } from "../../../packages/state/src/useSessionStore";
import type { SessionState } from "../../../packages/state/src/useSessionStore";
import { AnalyticsProvider } from "../../../packages/ui/src/components/AnalyticsProvider";

function HomeWithNavigation() {
  const navigate = useNavigate();
  return <Dashboard onServicePress={(service) => {
    console.log('service', service);
    if( service === 'send') {
      navigate("/send")
    } else if (service === "pickup") {
      navigate("/receive")
    } else {
      navigate("/billPay")
    }
  }} />;
}

function MainSendCashScreenNavigation() {
  const navigate = useNavigate();
  const kioskId = useSessionStore((s: SessionState) => (s as any).kioskId);
  const resetSession = useSessionStore((s) => s.reset);
  return <MainSendCashScreen handleClose={() => {
    navigate("/")}}
    handleFinish={() => {
      // clears store to initial state
      resetSession();
      try {
        // Prefer kioskId from store; fallback to URL param if missing
        const kidFromStore = kioskId && String(kioskId).trim();
        if (kidFromStore) {
          navigate(`/?t=${encodeURIComponent(kidFromStore)}`);
        } else {
          const params = new URLSearchParams(window.location.search);
          const kid = params.get('t');
          if (kid) {
            navigate(`/?t=${encodeURIComponent(kid)}`);
          } else {
            navigate(`/`);
          }
        }
      } catch {
        navigate(`/`);
      }
    }} />;
}

function MainReceiveScreenNavigation() {
  const navigate = useNavigate();
  const kioskId = useSessionStore((s: SessionState) => (s as any).kioskId);
  const resetSession = useSessionStore((s) => s.reset);
  return <MainReceiveScreen handleClose={() => {
    navigate("/")}}
    handleFinish={() => {
      // clears store to initial state
      resetSession();
      try {
        const kidFromStore = kioskId && String(kioskId).trim();
        if (kidFromStore) {
          navigate(`/?t=${encodeURIComponent(kidFromStore)}`);
        } else {
          const params = new URLSearchParams(window.location.search);
          const kid = params.get('t');
          if (kid) {
            navigate(`/?t=${encodeURIComponent(kid)}`);
          } else {
            navigate(`/`);
          }
        }
      } catch {
        navigate(`/`);
      }
    }} />;
}

function MainBillPayScreenNavigation() {
  const navigate = useNavigate();
  const kioskId = useSessionStore((s: SessionState) => (s as any).kioskId);
  const resetSession = useSessionStore((s) => s.reset);
  return <MainBillPayScreen handleClose={() => {
    navigate("/")}}
    handleFinish={() => {
      // clears store to initial state
      resetSession();
      try {
        const kidFromStore = kioskId && String(kioskId).trim();
        if (kidFromStore) {
          navigate(`/?t=${encodeURIComponent(kidFromStore)}`);
        } else {
          const params = new URLSearchParams(window.location.search);
          const kid = params.get('t');
          if (kid) {
            navigate(`/?t=${encodeURIComponent(kid)}`);
          } else {
            navigate(`/`);
          }
        }
      } catch {
        navigate(`/`);
      }
    }} />;
}

export default function App() {
  return (
    <AnalyticsProvider>
    <BrowserRouter>
      <GlobalErrorProvider> 
        <Routes>
          <Route path="/" element={<HomeWithNavigation />} />
          <Route path="/send" element={<MainSendCashScreenNavigation />} />
          <Route path="/receive" element={<MainReceiveScreenNavigation />} />
          <Route path="/billPay" element={<MainBillPayScreenNavigation />} />
        </Routes>
        <GlobalLoader />
      </GlobalErrorProvider> 
    </BrowserRouter>
    </AnalyticsProvider>
  );
}
